import Media from "emun.media/media.model";
import ServiceBusController from "servicestack/service-bus.controller";
import Product from "emun.shopping/product.model";
import cartItemQuickViewPrompt from "emun.cart/cart-item-quick-view-prompt";

export default class MediaGalleryItemController extends ServiceBusController {
  $onInit() {
    console.info("$onInit", this);
    const $ctrl = this;
    $ctrl.bus.send("QueryMedia?Id=" + $ctrl.mediaId).then(function (res) {
      if (res.data.results.length) {
        $ctrl.media = new Media(res.data.results[0]);
        $ctrl.bus
          .send(
            "QueryProducts.json?IdIn=" + $ctrl.media.tags["$skus"].join(",")
          )
          .then(function (res) {
            $ctrl.products = res.data.results.map((m) => new Product(m));
          });
      }
    });
  }
  quickView(product) {
    const $ctrl = this;
    return cartItemQuickViewPrompt({
      cartItem: product.createCartItem(),
      product: product,
    });
  }
}
